import { Controller } from '../utils/controller';

export default class extends Controller {
  static values = {
    src: String,
    srcMobile: String,
    posterSrc: String,
    posterSrcMobile: String
  };

  static targets = ['video'];

  declare readonly videoTarget: HTMLVideoElement;

  declare srcValue: string;
  declare srcMobileValue: string;
  declare posterSrcValue: string;
  declare posterSrcMobileValue: string;

  connect() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  handleResize() {
    this.updateSrc();
    this.updatePoster();
  }

  updateSrc() {
    const previousVideoSrc = this.videoTarget.src;
    const newVideoSrc = this.buildSrc();

    if (previousVideoSrc != newVideoSrc) {
      this.videoTarget.src = newVideoSrc;
    }
  }

  updatePoster() {
    const desktopBreakpoint = 1024;
    const previousPosterSrc = this.videoTarget.poster;
    const newPosterSrc =
      window.innerWidth >= desktopBreakpoint
        ? this.posterSrcValue
        : this.posterSrcMobileValue || this.posterSrcValue;

    if (previousPosterSrc != newPosterSrc) {
      this.videoTarget.poster = newPosterSrc;
    }
  }

  buildSrc() {
    const src = this.isDesktop() ? this.srcValue : this.srcMobileValue || this.srcValue;
    const mediaFragment = !this.hasMobilePoster() && this.isIOS() ? '#t=0.001' : '';

    return `${src}${mediaFragment}`;
  }

  hasMobilePoster() {
    return !!this.posterSrcMobileValue;
  }

  isDesktop() {
    const desktopBreakpoint = 1024;

    return window.innerWidth >= desktopBreakpoint;
  }

  isIOS() {
    return /iPad|iPhone/.test(navigator.userAgent);
  }
}
